import styled from "@emotion/styled";

export const TableStyle = styled.table`
    overflow: hidden;
    border-radius: 0.375rem;
    border-top-width: 1px;
    border-color: #d1d5db;
    min-width: 100%;
    background-color: #9ca3af;
    box-shadow:
        0 1px 3px 0 rgba(0, 0, 0, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-collapse: collapse;
    border-spacing: 0;
`;

export const THead = styled.thead`
    background-color: rgb(224, 242, 254);
`;

// `sortable` is not a valid HTML attribute, so emotion keeps it off the DOM.
export const Th = styled.th<{ sortable?: boolean }>`
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    text-align: left;
    color: #111827;
    text-align: center;
    font-family: Helvetica, Arial, sans-serif;
    padding: 1rem;
    background: rgb(247, 250, 252);
    border-bottom: 2px solid rgb(226, 232, 240);
    div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        // Only a column that actually sorts invites a click.
        cursor: ${(props) => (props.sortable ? "pointer" : "default")};
    }
`;

export const TBody = styled.tbody`
    border-top-width: 1px;
    border-color: #e5e7eb;
    background-color: #ffffff;
`;

export const FooterColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const FooterColumnContent = styled.div`
    font-size: 1rem;
    line-height: 2.25rem;
    color: #ffffff;
`;

// The spinner inherits its colour from currentColor, so it matches the empty
// state's text rather than carrying a colour of its own.
export const LoadingColumnContent = styled(FooterColumnContent)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
`;

export const Pagination = styled.nav`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    font-family: Helvetica, Arial, sans-serif;
`;

export const PageButton = styled.button`
    padding: 0.4rem 0.9rem;
    border-radius: 0.375rem;
    border: 1px solid rgb(226, 232, 240);
    background-color: #ffffff;
    color: #111827;
    font-size: 0.875rem;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: rgb(22 59 93);
        color: #ffffff;
        border-color: rgb(22 59 93);
    }

    &:disabled {
        opacity: 0.45;
        cursor: default;
    }
`;

export const PageStatus = styled.span`
    font-size: 0.875rem;
    color: #111827;
    // Digits only, so it needs no translating.
    font-variant-numeric: tabular-nums;
`;
